import { View, Text } from 'react-native'
import { DSColor } from '@ppwr/poker'
import { LeaderboardPlayer } from '../../LeaderboardList'
import { styles } from './ItemStyle'
import { PlayerAvatar } from '../../../PlayerAvatar'
import { DS } from '@/design-system'

interface ItemProps {
  isHighlighted: boolean
  index: number
  player: LeaderboardPlayer
  color: DSColor | undefined
}

export const Item = ({ player, isHighlighted, index, color: playerColor }: ItemProps) => {
  const statusSuffix = player?.isRemovedByTeacher ? ' (Removed)' : ''

  return (
    <View style={[styles.container, isHighlighted ? { backgroundColor: DS.palette['Global/White'] } : {}]}>
      <View style={{ flex: 0.3, paddingLeft: 16 }}>
        <DS.Text variant="Body Medium/Regular">{index + 1}</DS.Text>
      </View>
      <View style={styles.userSection}>
        <View style={styles.avatar}>
          <PlayerAvatar
            key={`$player-avatar-1-${index}`}
            name={player.playerName ?? ''}
            color={playerColor}
            invert
            size={4}
          />
        </View>
        <View style={styles.userName}>
          <View style={styles.userNameContent}>
            <Text
              style={[styles.text, styles.userNameText, { textDecorationLine: player?.isLeft ? 'line-through' : 'none' }]}
            >
              {player.playerName}
              {statusSuffix}
            </Text>
            {player.metaLabel ? (
              <DS.Text variant="Mini/Regular" color="Brand/Dark Grey" style={styles.metaText}>
                {player.metaLabel}
              </DS.Text>
            ) : null}
          </View>
        </View>
      </View>
      <View style={{ flex: 0.4 }}>
        <DS.Text variant="Body Medium/Medium" textAlign="center">
          {player.chips?.toLocaleString() ?? 0}
        </DS.Text>
      </View>
    </View>
  )
}
